import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSuitcase: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSuitcase"><Path fillRule="evenodd" clipRule="evenodd" d="M8 2H16V5H21V21H18V22H16.5V21H7.5V22H6V21H3V5H8V2ZM9.5 5H14.5V3.5H9.5V5ZM9.5 9V17H8V9H9.5ZM16 9V17H14.5V9H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSuitcase;
